import type { IEvent } from 'bz-utilities/modules/plugins/register/stores/mediator';

export class TemplatesUpdatedEvent implements IEvent {}
